import React from 'react'
import classnames from 'classnames/bind'

// Components

// Styles
import styles from './style.module.scss'

// Constants
import { TAG } from '@/constants/tag'

const cx = classnames.bind(styles)

export interface ITag {
  style: number
  name: string
  isLiveMallClub?: boolean
}

const Tag = (props: ITag) => {
  const { style, name, isLiveMallClub } = props

  return (
    <label
      className={cx('tag', {
        'tag--style-orange': style === TAG.ORANGE,
        'tag--style-pink': style === TAG.PINK,
        'tag--style-red': style === TAG.RED,
        isLiveMallClub,
      })}
    >
      <span className={cx('tag__name')}>{name}</span>
    </label>
  )
}

export default Tag
